<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import diasLaboralesAPI from "@/services/standards/diasLaborales/diasLaboralesAPI";
import { dateFormatYear } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import MedicionIncidenciaPagination from "../../../components/standard/medicionIncidencia/MedicionIncidenciaPagination.vue";
import MedicionAusentismoFichaPagination from "../../../components/standard/medicionAusentismo/MedicionAusentismoFichaPagination.vue";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Configurar días laborables",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
    MedicionIncidenciaPagination,
    MedicionAusentismoFichaPagination,
  },
  data() {
    return {
      title: "3.3.6 Configurar días laborables",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Medición del ausentismo por causa médica",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/medicion-ausentismo-registro`,
        },
        {
          text: "Configurar días laborables",
          active: true,
        },
      ],

      itemData: null,
      item: null,
      search: "",
      years: [],
      yearError: false,
      selectedYear: null,
      lista: [],
      loading: true,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      dias: {
        year: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,

        data: [
          {
            cuantity_days: 0,
            mounth: 1,
          },
          {
            cuantity_days: 0,
            mounth: 2,
          },
          {
            cuantity_days: 0,
            mounth: 3,
          },
          {
            cuantity_days: 0,
            mounth: 4,
          },
          {
            cuantity_days: 0,
            mounth: 5,
          },
          {
            cuantity_days: 0,
            mounth: 6,
          },
          {
            cuantity_days: 0,
            mounth: 7,
          },
          {
            cuantity_days: 0,
            mounth: 8,
          },
          {
            cuantity_days: 0,
            mounth: 9,
          },
          {
            cuantity_days: 0,
            mounth: 10,
          },
          {
            cuantity_days: 0,
            mounth: 11,
          },
          {
            cuantity_days: 0,
            mounth: 12,
          },
        ],
      },
    };
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(40)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 40)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    save() {
      // Validar si el año ya existe
      const yearsArray = Object.values(this.lista);
      const yearExists = yearsArray.some(item => item === this.dias.year);

      if (yearExists) {
        Swal.fire({
          title: "Error, el año ya existe!",
          text: "Error, el año ya existe!",
          type: "error",
          icon: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        return; // No proceder con la llamada a la API
      }

      diasLaboralesAPI
        .save(this.dias)
        .then((response) => {
          if (response.message === "Exito, días laborales creados!") {
            setTimeout(() => {
              Swal.fire({
                title: "¡Se ha registrado con éxito!",
                text: "¡Se ha registrado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });

              window.location.reload();
            }, 1000);
          } else if (response.message === "Error, el año ya existe!") {
            Swal.fire({
              title: "Error, el año ya existe!",
              text: "Error, el año ya existe!",
              type: "error",
              icon: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      diasLaboralesAPI
        .get(this.companyID)
        .then((response) => {
          this.lista = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    validateYear() {
      const yearsArray = Object.values(this.lista);
      this.yearError = yearsArray.some(item => item === this.selectedYear);
      this.dias.year = this.selectedYear;
    },

    dateConvert(date) {
      return dateFormatYear(date);
    },

    goBack() {
      this.$router.go(-1);
    },

    rangeYear() {
      const max = 2040;
      const min = 2019;

      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years
    },

    goPage(page) {
      window.location.href = page;
    },
  },

  mounted() {
    this.rangeYear();
    this.getList();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12 m-0 p-0">
        <div class="card">
          <div class="card-body">
            <div class="row px-3">
              <div class="col-12 text-right m-b-0">
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="back" placement="left"> Volver </b-tooltip>
              </div>
            </div>

            <hr />

            <div class="px-4">
              <h4>Configurar días laborables</h4>
            </div>
            <form class="row pt-3 pl-2" @submit.prevent="save">

              <b-form-group class="col-md-3 px-4" label="Seleccione el año" label-for="year-select">
                <b-form-select id="year-select" v-model="selectedYear" @change="validateYear" :options="years"
                  :disabled="loading"></b-form-select>
                <div v-if="yearError" class="text-danger">
                  <small><b>El año seleccionado ya existe en los registros.</b></small>
                </div>
              </b-form-group>
              <div class="col-6 px-4 mt-2" v-if="getRole('Consultar')">
                <table class="table-sm pt-2 table border-bottom divide-y divide-gray-200 table-bordered rounded">
                  <thead class="bg-primary text-light">
                    <tr>
                      <th class="text-center align-middle">Mes</th>
                      <th class="text-center align-middle">Días laborales</th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Enero</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[0].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Febrero</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[1].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Marzo</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[2].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Abril</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[3].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Mayo</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[4].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Junio</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[5].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Julio</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[6].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Agosto</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[7].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Septiembre</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[8].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Octubre</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[9].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Noviembre</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[10].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Diciembre</b>
                      </td>
                      <td class="text-center align-middle d-flex justify-content-center">
                        <b-form-input class="col-6" type="number" :disabled="!getRole('Crear') || !allowAccess()"
                          v-model="dias.data[11].cuantity_days" min="0" max="100"></b-form-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-group text-right m-b-0 mt-3">
                  <button @click="" type="submit" name="boton" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </div>

              <hr v-if="getRole('Consultar')" />

              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3 px-4">
                      <div class="col-6">
                        <form @submit.prevent="fetch()" class="form-inline">
                          <div class="form-group mr-2">
                            <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                              class="form-control px-2" placeholder="Buscar"></b-form-input>

                            <div class="col-1">
                              <button type="submit" class="btn btn-primary px-2">
                                Buscar
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
            </form>
            <div class="table-responsive px-5">
              <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                <thead>
                  <tr>
                    <th class="text-center align-middle">Año</th>

                    <th class="text-center align-middle">Acciones</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="dato in lista">
                    <td class="text-center align-middle">
                      {{ dato }}
                    </td>

                    <td class="text-center align-middle">
                      <div class="col-sm-12">
                        <b-dropdown variant="primary">
                          <template v-slot:button-content>
                            <i class="mdi mdi-eye"></i>
                          </template>
                          <b-dropdown-item :to="{
                            path: `/forms/estandares/dias-laborales-ver/${dato}`,
                          }">
                            Ver</b-dropdown-item>
                          <b-dropdown-item :to="{
                            path: `/forms/estandares/dias-laborales-editar/${dato}`,
                          }">
                            Editar</b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
